<template>
    <div>
        <headline-container headline="Marketing Sites" :breadcrumbs="breadcrumbs"/>

        <div class="container">
            <list-panel/>
        </div>
    </div>
</template>

<script>
    import HeadlineContainer from '@/components/Layout/HeadlineContainer'
    import ListPanel from '@/components/Panels/Administration/MarketingSites/Portals/List'

    export default {
        components: {HeadlineContainer, ListPanel},

        computed: {
            breadcrumbs() {
                return [
                    {text: 'Marketing Sites'}
                ]
            }
        }
    }
</script>
